import React, {useCallback} from 'react';

import {ACCOUNT_STRIP_LABELS} from 'src/components/criteria-strip/constants';
import {useLicenseCrmModules} from 'src/hooks/dictionaries';
import {CrmType as CrmTypes} from 'src/openapi/admin/models/CrmType';

import {CheckBox} from '@pb/kit-component-checkbox';
import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import {Group} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';


import type {SearchCriteria} from 'src/components/criteria-strip/services/criteria-strip-slice';

type Props = {
    width: number,
    criteria: SearchCriteria,
    onChange: (crmIntegrations: string[], includeInactiveCrm: boolean) => void,
};

export const CrmIntegrations = ({criteria, width, onChange}: Props) => {
    const {licenseCrmModules} = useLicenseCrmModules();

    const changeCrmIntegrations = useCallback((crmIntegrations: string[]) => {
        const includeInactiveCrm = !!criteria.crmIntegrations?.some(({value}) => value === 'includeInactiveCrm');
        onChange(crmIntegrations, includeInactiveCrm);
    }, [onChange, criteria]);

    const setInactiveCrm = useCallback((e: {
        event: React.SyntheticEvent<HTMLInputElement, Event>,
        name: string,
    }) => {
        const crmIntegrations = criteria
            .crmIntegrations?.filter(({value}) => value !== 'includeInactiveCrm')
            .map(({value}) => value) || [];
        const includeInactiveCrm = e.event.currentTarget.checked;

        onChange(crmIntegrations, includeInactiveCrm);
    }, [onChange, criteria]);

    return (
        <div style={{width}}>
            <Group justify="space-between">
                <Label>{ACCOUNT_STRIP_LABELS.crmIntegrations}</Label>
                <Group gap="s">
                    Include inactive licenses
                    <CheckBox
                        disabled={!criteria.crmIntegrations}
                        checked={criteria.crmIntegrations?.some(({value}) => value === 'includeInactiveCrm')}
                        onCheckBoxChange={setInactiveCrm}
                    />
                </Group>
            </Group>
            <ComboBox
                value={
                    criteria.crmIntegrations?.filter(({value}) => value !== 'includeInactiveCrm')
                        .map(({value}) => value) || []
                }
                multiselectable={true}
                placeholder="Select integration types"
                onChange={changeCrmIntegrations}>
                {licenseCrmModules.filter(({code}) => code !== CrmTypes.PITCHBOOK).map(({code, description}) => (
                    <ComboboxItem caption={description} value={code} key={code}/>
                ))}
            </ComboBox>
        </div>
    );
};
